import {
  VOTER_CLASSIFICATION_META,
  normalizeVoterClassification,
} from '../../config/voterClassification';
import { classNames } from '../../utils/classNames';

function ClassificationStatus({ classification, generatesExpense, compact = false }) {
  const normalized = normalizeVoterClassification(classification);
  const meta = VOTER_CLASSIFICATION_META[normalized];
  const expenseEnabled = Boolean(generatesExpense);

  return (
    <div className={classNames('min-w-0', !compact && 'rounded-card border bg-white p-4')}>
      <div className="flex flex-wrap items-center gap-2">
        <span className={classNames('inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-xs font-semibold', meta.badgeClass)}>
          <span className={classNames('size-2 rounded-full', meta.dotClass)} aria-hidden="true" />
          Clasificación: {meta.label}
        </span>
        <span className={classNames(
          'rounded-full px-2.5 py-1 text-xs font-semibold',
          expenseEnabled ? 'bg-warning-50 text-warning-700' : 'bg-success-50 text-success-700'
        )}>
          Estado de gasto: {expenseEnabled ? 'Genera gasto' : 'No genera gasto'}
        </span>
      </div>
      <p className={classNames('text-content-muted', compact ? 'mt-1.5 text-xs' : 'mt-3 text-sm')}>
        {meta.description} {meta.expenseLabel}.
      </p>
    </div>
  );
}

export default ClassificationStatus;
